module.exports = __webpack_public_path__ + "img/second-name_icon.a7f6634b.svg";